// extracted by mini-css-extract-plugin
export default {"swiperClass":"Swiper_swiperClass__TdXpm","swiperthree":"Swiper_swiperthree__6SPPd","box":"Swiper_box__onRoQ"};